import { OnImmediate } from "./useDomAnimationHelper.awaiter.js";
import type {
  StepsDefinition,
  HelperAwaiter,
  HelperProcessState,
} from "./useDomAnimationHelper.types.js";

type NormalizedSteps = [
  forwardSteps: [string, HelperAwaiter][],
  backwardSteps: [string, HelperAwaiter][],
];

export type InternalState = HelperProcessState & Record<string, boolean | undefined>;

/**
 *
 *
 *
 *
 *
 */
export const normalizeSteps = (stepsDefinition: StepsDefinition): NormalizedSteps => {
  /*                    */
  const normalizedSteps = Object.entries(stepsDefinition).map(([stepName, stepTriggers]) => {
    /*                                   */
    const triggers = Array.isArray(stepTriggers) ? stepTriggers : [stepTriggers, stepTriggers];

    /*                                                         */
    triggers[0] ??= OnImmediate;
    triggers[1] ??= OnImmediate;

    /*                        */
    return [stepName as string, triggers as [HelperAwaiter, HelperAwaiter]] as const;
  });

  /*                                                                    */
  return [
    /*              */
    normalizedSteps.map((s) => [s[0], s[1][0]]),
    /*                        */
    normalizedSteps.reverse().map((s) => [s[0], s[1][1]]),
  ];
};

export const getStepsNormalizer =
  (stepsDefinition: StepsDefinition, result?: NormalizedSteps) => (targetValue: boolean) => {
    /*                          */
    /*                                         */
    if (!result) result = normalizeSteps(stepsDefinition);
    /*                                             */
    return targetValue ? result[0] : result[1];
  };

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function processAnimationSteps(
  this: InternalState,
  stepKeys: string[],
  getSteps: ReturnType<typeof getStepsNormalizer>,
  targetValue: boolean,
): void {
  /*                                                              */
  /*                                 */
  const firstStepName = targetValue ? stepKeys[0] : stepKeys[stepKeys.length - 1];

  /*                                   */
  if (this[firstStepName] === targetValue) return;

  /*                                            */
  const [first, ...rest] = getSteps(targetValue);
  this.$direction = targetValue ? "in" : "out";
  this.$animIn = targetValue;
  this.$animOut = !targetValue;

  /*                                                    */
  let lastPromise: Promise<void> = first[1].call(
    first[0],
    targetValue,
    (v) => (this[first[0]] = v),
  );

  /*                          */
  for (const [stepName, stepAwaiter] of rest) {
    lastPromise = lastPromise.then(
      stepAwaiter.bind(stepName, targetValue, (v) => (this[stepName] = v)),
    );
  }

  /*                                                                                   */
  lastPromise.finally(() => {
    this.$animIn = false;
    this.$animOut = false;
    this.$direction = undefined;
  });
}
